import { Link } from 'react-router-dom';
import { latestNews } from '@/mocks/homeData';

export default function LatestSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="mb-8">
          <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-400 bg-background-200/60 rounded-full mb-3">
            最新资讯
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
            动漫与赛事最新动态
          </h2>
          <p className="text-foreground-500 text-sm">
            第一时间获取动漫资讯和NBA赛事热点
          </p>
        </div>

        {/* News grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {latestNews.map((news, idx) => (
            <Link
              key={news.id}
              to={`/article/${news.id}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              {/* Cover */}
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={news.cover}
                  alt={news.title}
                  className="w-full h-full object-cover transition-transform duration-400 group-hover:scale-105"
                  loading={idx === 0 ? 'eager' : 'lazy'}
                />
              </div>
              {/* Content */}
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700">
                    {news.category}
                  </span>
                  <span className="text-xs text-foreground-400">{news.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                  {news.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {news.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}